<template lang="pug">
	include conversionOrExistingPlusAdditions.pug
</template>

<script>
import uploadPopUp from '@/commonSite/uploadFiles'
// import _price from '@/commonSite/prices'
import _ from 'lodash'
import Vue from 'vue'

export default {
	name: 'existing-plus-additions',
	components: {
		uploadPopUp
	},
	props: ['wichComponent'],
	data: function () {
		return {
			navLinks: {},
			sqft: '',
			status: 'not_accepted',
			NofUnique: '',
			opUpFourDwellingsYes: '',
			// price: _price,
			newFloor: '',
			upFourDwellings: false,
			uniqueUnitType: 1,	// always : >=1
			exstFloor: '',
			adtnFloor: '',
			adtnOnlyFloor: '',
			lowEstimate: 0,
			hiEstimate: 0,
			selfServe: 0,
			estmtParts: {
				new: false,
				existingPlusAdd: true,
				add: false
			},
			totalEstimate: 0,
			additionCheck: false
		}
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
	},
	created () {
		this.price = this.$e24Common.storageService.findItem('config', true).estimator
		// console.log('beforeCreate in comp estimator', this.price)
		Vue.e24Common.productService.findAll().then((products) => {
			// console.log('product loaded', products)
			this.products = products
			this.products = _.map(this.products, (prod) => {
				// prod.price = prod.price.toFixed(2)
				prod.price = prod.price
				// console.log('prod ', prod.price)
				return prod
			})
			this.dataReady = true
		})
	},
	computed: {
		existingComponent () {
			if (this.wichComponent === 'existing') {
				return true
			} else {
				return false
			}
		},
		conversionComponent () {
			if (this.wichComponent === 'conversion') {
				return true
			} else {
				return false
			}
		}
	},
	methods: {
		findBySku (sku) {
			return _.find(this.products, { sku: sku.toString() })
		},
		doExstPlusAdtn (sel) {
			// console.log(`conversionPlusAdd is on`)
			// if we clicked on the 'Existing Plus Addition' radio button
			// copy any addition values into the newFloor area,
			if (sel) {
				if (this.newFloor > 0) {
					this.exstFloor = this.newFloor
				}
				if (this.adtnOnlyFloor > 0) {
					this.adtnFloor = this.adtnOnlyFloor
				}
			}

			// clear the other area inputs
			this.newFloor = ''
			this.adtnOnlyFloor = ''

			if (this.validateNumber(this.exstFloor) === false ||
				this.validateNumber(this.adtnFloor) === false) {
				return
			}

			// calculate the estimate
			if (this.exstFloor > 0 && this.adtnFloor > 0) {
				var sumAreas = this.exstFloor * 1 + this.adtnFloor * 1
				this.totalEstimate = Math.round(Math.max(this.price.resid.exstPlusAdtnBase, (sumAreas * this.price.resid.exstPlusAdtnPerFoot) - this.price.resid.estmOffset))
				this.lowEstimate = this.totalEstimate
				this.hiEstimate = this.totalEstimate + (this.price.resid.estmOffset * 2)
				this.selfServe = this.findBySku(1002).price
				// this.selfServe = this.price.resid.exstPlusAdtnSelfServe
			} else if (this.exstFloor > 0 && this.adtnFloor === 0) {
			// If someone enters 0 for the Addition Conditioned Floor Area,
			// then the fee will still be $295 (that will be a "Prescriptive Alteration"
			// Title 24 report)
				this.lowEstimate = this.price.resid.adtnOnlyBase
				this.hiEstimate = this.price.resid.adtnOnlyBase + (this.price.resid.estmOffset * 2)
				this.selfServe = 0
			} else {
				this.lowEstimate = 0
				this.hiEstimate = 0
				this.selfServe = 0
			}
		},
		validateNumber (anInput) {
			let reg = new RegExp('^[0-9]*$', 'g') // this only detect numbers
			// let reg2 = new RegExp('^-?\d*(\.\d+)?$') // this detects .0 and -9
			if (!reg.test(anInput)) {
				return false
			} else {
				return true
			}
		},
		// selType (type) {
		// 	this.switchType(type)
		// },
		dwellingsSel () {
			this.upFourDwellings = !this.upFourDwellings
			this.doNewBuilding(false)
		},
		setUnitTypeNum (uTypeNum) {
			this.uniqueUnitType = uTypeNum
			// this.uniqueUnitType = this.uniqueUnitType
			this.doNewBuilding(false)
		},
		doNewBuilding (sel) {
			// if we clicked on the 'New Building' radio button
			// copy any addition values into the newFloor area,
			if (sel) {
				if (this.adtnFloor > 0) {
					this.newFloor = this.adtnFloor
				}
				if (this.adtnOnlyFloor > 0) {
					this.newFloor = this.adtnOnlyFloor
				}
			}

			// clear the other area inputs
			this.exstFloor = ''
			this.adtnFloor = ''
			this.adtnOnlyFloor = ''

			if (this.validateNumber(this.newFloor) === false && !this.upFourDwellings) {
				return
			}
			// console.log(`this.upFourDwelling ${this.upFourDwellings}`)
			// calculate the estimate
			if (this.newFloor > 0 || this.upFourDwellings) {
				var extraDwellingsCost = 0
				if (this.upFourDwellings) {
					if (this.uniqueUnitType >= 1) {
						extraDwellingsCost = this.uniqueUnitType * this.price.resid.uniqueUnitType
						var estimate = Math.max(this.price.resid.multiFamilyBase, extraDwellingsCost)

						this.lowEstimate = estimate
						this.hiEstimate = estimate
					} else {
						alert('Unique unit type must be greater or equal than 1')
					}
				} else {
					this.totalEstimate = Math.round(Math.max(this.price.resid.newBuildingBase, (this.newFloor * this.price.resid.newBuildingPerFoot) - this.price.resid.estmOffset))
					this.lowEstimate = this.totalEstimate
					this.hiEstimate = this.totalEstimate + (this.price.resid.estmOffset * 2)
				}

				this.selfServe = this.findBySku(1001).price
				// this.selfServe = this.price.resid.newBuildingSelfServe
			} else {
				this.lowEstimate = 0
				this.hiEstimate = 0
				this.selfServe = 0
			}
		} // doNewBuilding
	},
	doExstPlusAdtn2 (sel) {
		// this fn is working error
	}, // end doExstPlusAdtn
	doAdditionOnly (sel) {
		// if we clicked on the 'New Bulding' radio button
		// copy any addition values into the newFloor area,
		if (sel) {
			if (this.newFloor > 0) {
				this.adtnOnlyFloor = this.newFloor
			}
			if (this.adtnFloor > 0 && this.adtnFloor <= 700) {
				this.adtnOnlyFloor = this.adtnFloor
			}
		}
		if (this.adtnOnlyFloor > 700) {
			this.adtnFloor = this.adtnOnlyFloor
			this.adtnOnlyFloor = ''
			return
		}

		// clear the other area inputs
		this.newFloor = ''
		this.exstFloor = ''
		this.adtnFloor = ''

		if (this.validateNumber(this.adtnOnlyFloor) === false) {
			return
		}

		// calculate the estimate
		if (this.adtnOnlyFloor > 0) {
			this.totalEstimate = Math.round(Math.max(this.price.resid.adtnOnlyBase, (this.adtnOnlyFloor * this.price.resid.adtnOnlyPerFoot) - this.price.resid.estmOffset))
			this.lowEstimate = this.totalEstimate
			this.hiEstimate = this.totalEstimate + (this.price.resid.estmOffset * 2)
			this.selfServe = this.findBySku(1001).price
			// this.selfServe = this.price.resid.newBuildingSelfServe
		} else if (this.adtnOnlyFloor === 0) {
		// If someone enters 0 for the Addition Conditioned Floor Area,
		// then the fee will still be $295 (that will be a "Prescriptive Alteration"
		// Title 24 report)
			this.lowEstimate = this.price.resid.adtnOnlyBase
			this.hiEstimate = this.price.resid.adtnOnlyBase + (this.price.resid.estmOffset * 2)
			this.selfServe = this.findBySku(1002).price
			// this.selfServe = this.price.resid.adtnOnlySelfServe
		} else {
			this.lowEstimate = '0'
			this.hiEstimate = '0'
			this.selfServe = '0'
		}
	} // end doAdditionOnly
}
</script>



// WEBPACK FOOTER //
// src/components/complianceWizard/residentialWizards/conversionOrExistingPlusAdditions.vue